import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bspagination',
	templateUrl:'./BSPaginationPluginCompPage.html',
	styles: [],
	styleUrls:['./BSPaginationPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSPaginationPluginCompPage
{
	mdContent_847 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.pagination.BSPagination;
\`\`\``;
	mdContent_848 = `\`\`\`java
BSPagination()
\`\`\``;
	mdContent_849 = `\`\`\`java
BSPagination&lt;?&gt; pager = new BSPagination&lt;&gt;();
pager.setSize(BSSizes.Lg);
pager.setAlignment("center");
pager.setMaxSize(5);
\`\`\``;
}
